import ApiService from "@/common/api/api.service";
// segmentacao / bimestre
const SegmentacaoService = {
    async pegarPorAnoLetivoId(id) {
        let { data } = await ApiService.get(`Segmentacao/obter-por-anoLetivo?anoLetivoId=${id}`);
        return data;
    },
};

export default SegmentacaoService